import React from 'react';
import { ArticleTitle } from '../../../../components/ArticleTitle';
import { ArticleBreadcrumbs } from '../../../../components/ArticleBreadcrumbs';
import { ArticleCoverPhoto } from '../../../../components/ArticleCoverPhoto/v2';
import { ArticleShareIcons } from '../../../../components/ArticleShareIcons';
import { BehaviorDetails } from '../BehaviorDetails';
import { BehaviorArticleInfo } from '../BehaviorArticleInfo';
import { CamelizedBehaviorArticleResponse } from '../../../../types/api';
import { Box } from '../../../../wag-react/next-components/box';
import { theme } from '../../../../wag-react/themes/base-theme';
import { Divider } from '../../../../wag-react/core-components/divider';
export type BehaviorHeaderProps = CamelizedBehaviorArticleResponse;
export const BehaviorHeader = (props: BehaviorHeaderProps) => {
  const {
    breadcrumbs,
    title,
    heroImageUrl,
    shareUrls
  } = props;
  return <Box as="header" py={['16px', '32px']} data-sentry-element="Box" data-sentry-component="BehaviorHeader" data-sentry-source-file="index.tsx">
      <ArticleBreadcrumbs value={breadcrumbs} px={['16px', 'unset']} data-sentry-element="ArticleBreadcrumbs" data-sentry-source-file="index.tsx" />

      <BehaviorArticleInfo display={['grid', 'none']} mt={['32px', '40px']} px={['16px', 'unset']} {...props} data-sentry-element="BehaviorArticleInfo" data-sentry-source-file="index.tsx" />

      <ArticleTitle color={theme.colors.charcoal} mt={['unset', '40px']} mb="8px" px={['16px', 'unset']} data-sentry-element="ArticleTitle" data-sentry-source-file="index.tsx">
        {title}
      </ArticleTitle>

      <ArticleShareIcons as="div" display={['block', 'none']} value={shareUrls} title={title} position="initial" mb={['16px', 'unset']} containerProps={{
      position: 'initial',
      gridTemplateColumns: 'repeat(auto-fill, 64px)',
      gridGap: 0
    }} data-sentry-element="ArticleShareIcons" data-sentry-source-file="index.tsx" />

      <BehaviorArticleInfo display={['none', 'grid']} {...props} data-sentry-element="BehaviorArticleInfo" data-sentry-source-file="index.tsx" />

      <ArticleCoverPhoto src={heroImageUrl} alt={title} width={[1, null, '832px']} height={['200px', '440px']} borderRadius={['none', '8px']} data-sentry-element="ArticleCoverPhoto" data-sentry-source-file="index.tsx" />

      <BehaviorDetails {...props} data-sentry-element="BehaviorDetails" data-sentry-source-file="index.tsx" />

      <Divider height="2px" data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
    </Box>;
};